export default __webpack_public_path__ + "static/media/kelly-headshot.a276b334.jpg";